<template>
  <div>
    <div
      id="teamServiceItemModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header"></div>
          <div class="modal-body">
            <div class="row" v-if="permissionEditDriverService">
              <div class="col-sm-12">
                <div class="card">
                  <div
                    class="card-body"
                    style="
                      border-style: solid;
                      border-color: #c4c4c4;
                      margin-bottom: 5px;
                    "
                  >
                    <div class="row" style="margin: 10px 0">
                      <div class="col-md-12">
                        <input
                          type="text"
                          required="required"
                          class="inputstyle fontSize16 col-md-3"
                          placeholder="服務名稱"
                          v-model="serviceName"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row pull-right" v-if="permissionEditDriverService">
              <button class="btn btn-primary" @click="addServiceItem">
                +增加服務篩選項目
              </button>
            </div>
            <template>
              <el-table :data="serviceList" style="width: 100%">
                <!-- first col -->
                <el-table-column label="服務項目">
                  <template slot-scope="scope">
                    <el-input
                      v-if="scope.row.teamId === 1"
                      :placeholder="scope.row.name"
                      v-model="scope.row.name"
                      :disabled="true"
                    />
                    <el-input
                      v-else
                      :placeholder="scope.row.name"
                      v-model="scope.row.name"
                    />
                  </template>
                </el-table-column>
                <!-- second col -->
                <el-table-column label="勾選">
                  <template slot-scope="scope">
                    <div v-if="scope.row.teamId === 1">
                      若要在LINE顯示，請另外新增服務項目
                    </div>
                    <div v-else>
                      <el-checkbox v-model="scope.row.isWebPageCallingCar">
                        是否為 LINE 網頁叫車選擇
                      </el-checkbox>
                      <el-checkbox
                        v-model="scope.row.isChoosingCarSelection"
                        :checked="
                          deleteInputData(
                            scope.$index,
                            scope.row.isChoosingCarSelection,
                          )
                        "
                      >
                        是否能選擇車輛
                      </el-checkbox>
                      <div v-if="scope.row.isChoosingCarSelection">
                        <el-input
                          type="number"
                          :min="0"
                          placeholder="平日倍數（請輸入數字)"
                          v-model="scope.row.multipleOfNormal"
                        ></el-input>
                        <el-input
                          placeholder="尖峰倍數（請輸入數字)"
                          :min="0"
                          v-model="scope.row.multipleOfRush"
                        ></el-input>
                        <el-input
                          placeholder="特殊節慶倍數（請輸入數字)"
                          :min="0"
                          v-model="scope.row.multipleOfFestival"
                        ></el-input>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <!-- third col -->
                <el-table-column label="按鈕">
                  <template slot-scope="scope">
                    <div v-if="scope.row.teamId === 1">
                      系統預設項目不提供編輯
                    </div>
                    <div v-else>
                      <button
                        class="btn btn-primary"
                        @click="updateSerivceItem(scope.$index)"
                      >
                        更新服務項目
                      </button>
                      <button
                        class="btn btn-danger"
                        @click="removeServiceItem(scope.$index)"
                      >
                        移除服務項目
                      </button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              關閉
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import API from '@/assets/js/libs/API'
import { mapActions } from 'vuex'
import BehaviorRecorder from '@/assets/js/libs/BehaviorRecorder'
import CustomerizeService from '@/assets/js/libs/CustomerizeService'

const customerize = new CustomerizeService()

export default {
  props: ['permissionEditDriverService'],
  data() {
    return {
      serviceList: [],
      serviceName: '',
    }
  },
  mounted() {
    this.getTeamServiceList()
  },
  methods: {
    ...mapActions('hail', {
      vx_fetchServiceList: 'fetchServiceList',
    }),
    /* BUG: 更新服務目前有問題 */
    async updateSerivceItem(index) {
      const oldName = this.serviceList[index].originData.name
      const newName = this.serviceList[index].name
      // 只有有異動才紀錄
      if (oldName !== newName) {
        BehaviorRecorder.record(
          '點擊',
          '服務浮動框',
          '更新服務<' +
            newName +
            '>' +
            '&&名稱:' +
            '&&(原)' +
            oldName +
            ' &&(新)' +
            newName,
        )
      }
      // 合併倍率變動紀錄
      this.recordMultiplierChange(index, newName)
      this.recordCheckBoxChange(index)
      this.recordLineCheckBoxChange(index)
      try {
        const result = await customerize.update(this.serviceList[index])
        if (result.success) {
          this.getTeamServiceList()
          this.$msg('更新成功')
        } else {
          this.$msg(result.message)
        }
      } catch (e) {
        console.error(e)
      }
    },
    recordMultiplierChange(index, serviceName) {
      if (!this.serviceList[index].isChoosingCarSelection) return
      var oldNormal = this.serviceList[index].originData.multipleOfNormal || 0
      var newNormal = this.serviceList[index].multipleOfNormal || 0
      var oldRush = this.serviceList[index].originData.multipleOfRush || 0
      var newRush = this.serviceList[index].multipleOfRush || 0
      var oldFestival =
        this.serviceList[index].originData.multipleOfFestival || 0
      var newFestival = this.serviceList[index].multipleOfFestival || 0
      var msg = this.formatMultiplierChangeMessage(
        serviceName,
        oldNormal,
        newNormal,
        oldRush,
        newRush,
        oldFestival,
        newFestival,
      )
      if (msg) {
        BehaviorRecorder.record('點擊', '服務浮動框', msg)
      }
    },
    recordCheckBoxChange(index) {
      const originCheckbox =
        this.serviceList[index].originData.isChoosingCarSelection
      const newCheckbox = this.serviceList[index].isChoosingCarSelection
      if (originCheckbox !== newCheckbox && !newCheckbox) {
        {
          BehaviorRecorder.record(
            '點擊',
            '服務浮動框',
            '更新服務<' +
              this.serviceList[index].name +
              '> &&取消勾選 - 是否能選擇車輛',
          )
        }
      }
    },
    recordLineCheckBoxChange(index) {
      const originCheckbox =
        this.serviceList[index].originData.isWebPageCallingCar
      const newCheckbox = this.serviceList[index].isWebPageCallingCar
      if (originCheckbox !== newCheckbox) {
        if (newCheckbox) {
          BehaviorRecorder.record(
            '點擊',
            '服務浮動框',
            '更新服務<' +
              this.serviceList[index].name +
              '> &&勾選 - 是否為 LINE 網頁叫車選擇',
          )
        } else {
          BehaviorRecorder.record(
            '點擊',
            '服務浮動框',
            '更新服務<' +
              this.serviceList[index].name +
              '> &&取消勾選 - 是否為 LINE 網頁叫車選擇',
          )
        }
      }
    },
    async addServiceItem() {
      BehaviorRecorder.record(
        '點擊',
        '服務浮動框',
        '新增服務<' + this.serviceName + '>',
      )
      if (this.serviceName === '') return alert('請填入字串')
      try {
        const result = await customerize.create({
          name: this.serviceName,
          isWebPageCallingCar: false,
          isChoosingCarSelection: false,
          multipleOfNormal: 1,
          multipleOfRush: 1,
          multipleOfFestival: 1,
        })
        if (result.success) {
          this.serviceName = ''
          this.getTeamServiceList()
        }
      } catch (e) {
        console.error(e)
      }
    },
    async removeServiceItem(index) {
      BehaviorRecorder.record(
        '點擊',
        '服務浮動框',
        '移除服務<' + this.serviceList[index].name + '>',
      )
      try {
        const result = await customerize.delete({
          id: this.serviceList[index].id,
          team_id: this.serviceList[index].teamId,
        })
        if (result.success) {
          this.getTeamServiceList()
          this.$msg('刪除成功')
        } else {
          this.$msg('刪除發生錯誤')
        }
      } catch (e) {
        console.error(e)
        this.$msg('刪除發生錯誤')
      }
    },
    showModal() {
      $('#teamServiceItemModal').modal('show')
    },
    getTeamServiceList() {
      API.get('customerize/list')
        .then(({ result }) => {
          this.serviceList = result.serviceList
            .map((obj) => {
              if (obj.isWebPageCallingCar === null)
                obj.isWebPageCallingCar = false
              if (obj.isChoosingCarSelection === null)
                obj.isChoosingCarSelection = false
              obj.originData = { ...obj } // 複製一份原始資料以供比對使用
              return obj
            })
            .sort((a, b) => a.teamId - b.teamId)
          this.vx_fetchServiceList()
        })
        .catch((e) => console.error('saveCustomerInfo', e))
    },
    initialData() {
      this.feeItem = ''
      this.non_expired_fee = ''
      this.expired_fee = ''
      this.note = ''
    },
    deleteInputData(index, isCheck) {
      if (!isCheck) {
        this.serviceList[index].multipleOfRush = null
        this.serviceList[index].multipleOfNormal = null
        this.serviceList[index].multipleOfFestival = null
      }
    },
    formatMultiplierChangeMessage(
      serviceName,
      oldNormal,
      newNormal,
      oldRush,
      newRush,
      oldFestival,
      newFestival,
    ) {
      var msg = '更新服務<' + serviceName + '>'
      var detail = ''
      detail += '&&勾選 - 是否能選擇車輛'
      detail += '&&平日倍數:(原) ' + oldNormal + '  (新) ' + newNormal
      detail += '&&尖峰倍數:(原) ' + oldRush + '  (新) ' + newRush
      detail += '&&特殊節慶倍數:(原) ' + oldFestival + ' (新) ' + newFestival
      return msg + detail
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/driver/components/ServiceListModalBug.vue